<template>
  <div id="page-selects">
    <v-dialog v-model="dialogShowImage" persistent width="230">
      <v-card>
        <v-btn color="pink" dark small absolute right fab @click.native="hideToggleLockJobNumber">
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-text>
          <v-avatar
          :tile="true"
          :size="200"
          class="grey lighten-4"
          >
            <img :src="utils.imageProfile(selectedImage)" alt="" width="300" height="300">
          </v-avatar>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-container grid-list-xl fluid class="pa-2">
      <v-data-table
        v-model="vDataTable.selected"
        :headers="headersUser"
        :items="vDataTable.data"
        :search="vDataTable.search"
        fixed-header
        :page.sync="vDataTable.options.page"
        :itemsPerPage.sync="vDataTable.options.itemsPerPage"
        :options.sync="vDataTable.options"
        :height="$vuetify.breakpoint.height - 220"
        :footer-props="{
          itemsPerPageText: $t('itemsPerPageText'),
          itemsPerPageAllText: $t('itemsPerPageAllText'),
          showFirstLastPage: true,
          showCurrentPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
        item-key="global_key"
        class="elevation-1">
        <template v-slot:top>
          <v-row>
            <v-col cols="12" sm="12">
            <v-toolbar flat>
              <v-toolbar-title>Global Parms</v-toolbar-title>
            </v-toolbar>
            </v-col>
            <v-col cols="12" sm="12">
              <v-toolbar flat>
                <v-dialog v-model="dialog.dialogAddEditWindow" max-width="800px" eager>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize">
                      <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>Add Global Parms
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field outlined hide-details label="Global Key" v-model="vDataTable.editedItem.global_key"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field outlined hide-details label="Parm Value" v-model="vDataTable.editedItem.parm_value"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                              <v-textarea
                                outlined hide-details
                                color="black"
                                label="Description"
                                v-model="vDataTable.editedItem.description"
                              ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                        <v-btn outlined color="primary" @click="save">{{$t('save')}}</v-btn>
                        <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- <v-divider class="mx-1" inset vertical></v-divider>
                <v-btn class="text-right" outlined color="primary" style="text-transform: capitalize" @click="resetPassword">
                  <img src="../assets/SoftwareClinicIcon/woman-working-on-a-computer.jpg" height="30" weight="30"/>Reset password
                </v-btn> -->
                <v-spacer></v-spacer>
                <v-text-field
                  dense
                  v-model="vDataTable.search"
                  outlined
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details>
                </v-text-field>
              </v-toolbar>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="teal" small class="mr-2" @click="editItem(item)">edit</v-icon>
          <!-- <v-icon color="pink" small @click="deleteItemConfirm(item)">delete</v-icon> -->
        </template>
        <template v-slot:item.data-table-no="{ item, index }">
          {{index + 1}}
        </template>
        <template v-slot:no-data>
          <v-alert type="info" border="bottom" colored-border elevation="2">
            {{$t('noData')}}
          </v-alert>
        </template>
        <template v-slot:no-results>
          <v-alert type="warning" border="bottom" colored-border elevation="2">
            {{stringFormat($t('searchNotFound'),vDataTable.search)}}
          </v-alert>
        </template>
        <template v-slot:footer>
          <tr class="sticky-table-footer" style="position: absolute" >
              <td>Selected({{vDataTable.selected.length}})s</td> 
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog.dialogProgress" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            <span class="font-weight-bold dark white--text">{{progressMessage}}</span>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
            <!-- </div>
          </v-widget>
        </v-flex>
      </v-layout> -->
    </v-container>
  </div>
</template>

<script>
import Base64Binary from 'base64-arraybuffer'
// import { imageProfile } from '../utils'

export default {
  components: {
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      dialog: {
        dialogProgress: false,
        dialogAddEditWindow: false,
      },
      showMenu: false,
      x: 0,
      y: 0,
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          global_key: '',
          parm_value: '',
          description: '',
        },
        defaultItem: {
          global_key: '',
          parm_value: '',
          description: '',
        },
        options: {
          page: 1,
          itemsPerPage: -1,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      progressMessage: '',
      appSkey: -1,
      e3: true,
      dialogShowImage: false,
      selectedImage: null,
      dialogAddEditWindow: false,
      dialogProgress: false,
      searchUser: '',
      paginationUser: {
        sortBy: 'global_key',
        rowsPerPage: 10
      },
      selectedUser: [],
      dataUser: [],
      editedIndex: -1,
      editedItem: {
        global_key: '',
        parm_value: '',
        description: '',
      },
      deletedIndex: -1,
      deletedItem: {
        global_key: '',
        parm_value: '',
        description: '',
      },
      defaultItem: {
        global_key: '',
        parm_value: '',
        description: '',
      },
      dropDownData: [],
    }
  },

  computed: {
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? 'New Group' : 'Edit Group'
    },
    headersUser () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), sortable: false, value: 'actions', class: 'text-xl-left body-1 black--text' },
        { text: 'Global Key', value: 'global_key', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: 'Parm Value', value: 'parm_value', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: 'description', value: 'description', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    }
  },

  watch: {
    'dialog.dialogAddEditWindow' (val) {
      val || this.close()
    }
  },

  created: function () {
    this.retrieveGlobalParms()
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
      this.vDataTable.data = []
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        global_key: '',
        parm_value: '',
        description: '',
      }
      this.vDataTable.defaultItem = {
        global_key: '',
        parm_value: '',
        description: '',
      }
    },
    showToggleLockJobNumber (picture) {
      this.dialogShowImage = true
      this.selectedImage = picture
    },
    hideToggleLockJobNumber () {
      this.dialogShowImage = false
    },
    async retrieveGlobalParms () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/global_parms/retrieveGlobalParms' + process.env.VUE_APP_DATABASE_TYPE)
        .then(response => {
          if (response.data.isSuccess) {
            this.dialog.dialogProgress = false
            this.vDataTable.data = response.data.data
          } else {
            this.dialog.dialogProgress = false
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.dialog.dialogProgress = false
          this.$swal({type: 'error', title: e.message})
        })
    },
    async addGlobalParms (globalKey, parmValue, description) {
      await this.axios.post(process.env.VUE_APP_API + '/global_parms/addGlobalParms' + process.env.VUE_APP_DATABASE_TYPE, {
        global_key: globalKey,
        parm_value: parmValue,
        description: description,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data.push(this.vDataTable.editedItem)
            this.retrieveGlobalParms()
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async updateGlobalParms (groupSkey, parmValue, description) {
      await this.axios.post(process.env.VUE_APP_API + '/global_parms/updateGlobalParms' + process.env.VUE_APP_DATABASE_TYPE, {
        global_key: groupSkey,
        parm_value: parmValue,
        description: description,
      })
        .then(response => {
          if (response.data.isSuccess) {
            Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
            this.retrieveGlobalParms()
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    deleteGlobalParms (item) {
      var groupSkey = this.deletedItem.global_key
      this.dataUser.splice(this.deletedIndex, 1)
      groupSkey = item.global_key
      this.axios.post(process.env.VUE_APP_API + '/global_parms/deleteGlobalParms' + process.env.VUE_APP_DATABASE_TYPE, {
        global_key: groupSkey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.retrieveGlobalParms()
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    toggleAll () {
      if (this.selectedUser.length) this.selectedUser = []
      else this.selectedUser = this.dataUser.slice()
    },
    changeSort (column) {
      if (this.paginationUser.sortBy === column) {
        this.paginationUser.descending = !this.paginationUser.descending
      } else {
        this.paginationUser.sortBy = column
        this.paginationUser.descending = false
      }
    },
    /* editItem (item) {
      this.editedIndex = this.dataUser.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogAddEditWindow = true
    }, */
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEditWindow = true
    },
    async deleteItemConfirm (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: 'คุณต้องการที่จะลบข้อมูล Group ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteGlobalParms(this.vDataTable.editedItem)
          if (val !== undefined) {
            this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(this.vDataTable.editedItem), 1)
          }
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        }
      })
    },
    close () {
      this.dialog.dialogAddEditWindow = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.validateReg() === true) {
        if (this.vDataTable.editedIndex > -1) {
          await this.updateGlobalParms(this.vDataTable.editedItem.global_key,
            this.vDataTable.editedItem.parm_value,
            this.vDataTable.editedItem.description)
        } else {
          await this.addGlobalParms(this.vDataTable.editedItem.global_key,
            this.vDataTable.editedItem.parm_value,
            this.vDataTable.editedItem.description)
        }
        this.close()
      }
    },
    validateReg () {
      var messageCustom = ''
      if (!this.vDataTable.editedItem.global_key) {
        /* messageCustom = messageCustom + his.$t('EgatWebEmployee.messageEmployeeID') + '<br />' */
        messageCustom = messageCustom + 'Please Enter Global Key' + '<br />'
      }
      if (!this.vDataTable.editedItem.parm_value) {
        /* messageCustom = messageCustom + his.$t('EgatWebEmployee.messageEmployeeID') + '<br />' */
        messageCustom = messageCustom + 'Please Enter Parm Value' + '<br />'
      }
      if (!this.vDataTable.editedItem.description) {
        /* messageCustom = messageCustom + his.$t('EgatWebEmployee.messageEmployeeID') + '<br />' */
        messageCustom = messageCustom + 'Please Enter description' + '<br />'
      }
      if (messageCustom) {
        this.$swal({type: 'error', html: messageCustom})
        return false
      } else {
        return true
      }
    },
    resetPassword () {
      this.$swal({
        text: 'Reset Password',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then((result) => {
        if (result) {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          this.axios.post(process.env.VUE_APP_API + '/global_parms/resetPassword' + process.env.VUE_APP_DATABASE_TYPE)
            .then(response => {
              if (response.data.isSuccess) {
                this.dialog.dialogProgress = false
                this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
              } else {
                this.dialog.dialogProgress = false
                this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(e => {
              this.dialog.dialogProgress = false
              this.$swal({type: 'error', title: e.message})
            })
        }
      })
    }
  }
}
</script>

<style lang="css">
.dialog.centered-dialog,
.v-dialog.centered-dialog {
  background: #282c2dad;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  color: whitesmoke;
}
.DataTable {
  display: none;
  border: none;
}
.rounded-card {
  display: none;
  border: none;
}
</style>